import { render } from "./Banking.vue?vue&type=template&id=4d2eb77f&scoped=true&ts=true"
import script from "./Banking.vue?vue&type=script&lang=ts"
export * from "./Banking.vue?vue&type=script&lang=ts"

import "./Banking.vue?vue&type=style&index=0&id=4d2eb77f&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2eb77f"]])

export default __exports__